module.exports = __webpack_public_path__ + "static/media/SC2.e4b98630.jpg";